import { Result } from "antd";

const PageNotFound = () => {
  return (
    <div className="m-5">
      <Result
        status="500"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <i className="text-danger text-[20px] fa-solid fa-face-sad-cry fa-fade"></i>
        }
      />
    </div>
  );
};

export default PageNotFound;
